import * as yup from 'yup';

export const optimizedResourcesValidationSchema = yup.object({
  cpu: yup
    .boolean()
    .test(
      'cpu-or-memory',
      'CPU or memory is required',
      (value, ctx) => value || ctx.parent.memory
    )
    .required(),
  memory: yup
    .boolean()
    .test(
      'cpu-or-memory',
      'CPU or memory is required',
      (value, ctx) => value || ctx.parent.cpu
    )
    .required(),
});

export const optimizedResourcesWithGpuValidationSchema =
  optimizedResourcesValidationSchema.shape({
    gpu: yup.boolean().required(),
  });
